import React, { useContext } from 'react'
import DiagnosticImage from '@BUP/assets/Images/Data/diagnostic_image.svg'
import QuienesResponden from '@BUP/assets/Images/Data/data_¿quienes-responden.svg'
import Duracion from '@BUP/assets/Images/Data/data_¿duracion.svg'
import QueMide from '@BUP/assets/Images/Data/data_¿que-mide.svg'
import { useTranslation } from 'react-i18next'
import { isSociogram } from '@BUP/services/BraveUp'
import styles from './data-page-teacher.module.scss'
import PageLayout from '@BUP/components/Layout/Page'
import InfoCard from '@BUP/components/Generics/Cards/InfoCard'
import InfoCardItem from '@BUP/components/Generics/Cards/InfoCardItem'
import { OrganizationContext } from '@BUP/contexts/OrganizationContext'
import { RoleContext } from '@BUP/contexts/RoleContext'
import { TEACHER } from '@BUP/constants'
import SociogramImage from '@BUP/assets/Images/Data/sociogram_image.svg'
import MainTeacherValidation from './main-teacher-validation'
import InfoInstrumentCard from '@BUP/components/Generics/Cards/InstrumentCard/info-instrument-card'

const DataPageTeacher = () => {
  const i18n = useTranslation()
  const organization = useContext(OrganizationContext)
  const { id: organizationId } = organization
  const { type: roleType } = useContext(RoleContext)
  const isCurrentUserATeacher = roleType === TEACHER
  const locationName = organization.location.name

  return (
    <PageLayout pageName='BRAVE UP! DATA'>
      <>
        <p className={styles.intro_text}>
          {i18n.t('pages.data.instruments.teacher.introText')}
        </p>
        <div className={styles.instruments_container}>
          <div className={styles.sociogram_instrument_wrapper}>
            {isCurrentUserATeacher && isSociogram(organization)
              ? (
                <div className='DataPageTeacher-main-teacher-wrapper'>
                  <MainTeacherValidation organizationId={organizationId} />
                </div>
                )
              : (
                <InfoInstrumentCard
                  srcImage={SociogramImage}
                  title={i18n.t('pages.data.instruments.teacher.sociogram.title')}
                  description={i18n.t('pages.data.instruments.teacher.sociogram.description')}
                />
                )}
          </div>
          <InfoCard title={i18n.t('pages.data.instruments.teacher.sociogram.title')}>
            <InfoCardItem
              img={Duracion}
              title={i18n.t('pages.data.instruments.teacher.sociogram.question1')}
              description={i18n.t('pages.data.instruments.teacher.sociogram.answer1')}
            />
            <InfoCardItem
              img={QuienesResponden}
              title={i18n.t('pages.data.instruments.teacher.sociogram.question2')}
              description={i18n.t(
                'pages.data.instruments.teacher.sociogram.answer2'
              )}
            />
            <InfoCardItem
              img={QueMide}
              title={i18n.t('pages.data.instruments.teacher.sociogram.question3')}
              description={i18n.t(
                'pages.data.instruments.teacher.sociogram.answer3')}
            />
          </InfoCard>
          <InfoInstrumentCard
            srcImage={DiagnosticImage}
            title={i18n.t('pages.data.instruments.teacher.diagnosis.title')}
            description={i18n.t(
              'pages.data.instruments.teacher.diagnosis.description'
            )}
            isClickeable={false}
          />
          <InfoCard title={i18n.t('pages.data.instruments.teacher.diagnosis.title')}>
            <InfoCardItem
              img={Duracion}
              title={i18n.t('pages.data.instruments.teacher.diagnosis.question1')}
              description={i18n.t('pages.data.instruments.teacher.diagnosis.answer1')}
            />
            <InfoCardItem
              img={QuienesResponden}
              title={i18n.t('pages.data.instruments.teacher.diagnosis.question2')}
              description={
                locationName === 'Colombia' || locationName === 'Mexico' || locationName === 'Peru' ? i18n.t('pages.data.instruments.teacher.diagnosis.alternativeAnswer2') : i18n.t('pages.data.instruments.teacher.diagnosis.answer2')
              }
            />
            <InfoCardItem
              img={QueMide}
              title={i18n.t('pages.data.instruments.teacher.diagnosis.question3')}
              description={i18n.t(
                'pages.data.instruments.teacher.diagnosis.answer3'
              )}
            />
          </InfoCard>
        </div>
      </>
    </PageLayout>
  )
}
export default DataPageTeacher
